import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import NavBar from '../components/NavBar';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { supportAPI, formatApiError } from '../lib/api';
import { MessageCircle, Send } from 'lucide-react';

export default function Support() {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => supportAPI.myTickets().then(r => setTickets(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await supportAPI.createTicket(subject, message);
      toast.success('Destek talebiniz oluşturuldu');
      setSubject('');
      setMessage('');
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <NavBar />
      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2 flex items-center gap-2"><MessageCircle className="w-7 h-7 text-fuchsia-400" /> Canlı Destek</h1>
          <p className="text-muted-foreground">Bir sorun yaşarsanız talep oluşturun. Admin panelinden cevaplanır.</p>
        </div>
        <div className="grid lg:grid-cols-2 gap-6">
          <form onSubmit={submit} className="glass-card rounded-2xl p-6 space-y-4">
            <Input value={subject} onChange={(e)=>setSubject(e.target.value)} placeholder="Konu" className="bg-white/5 border-white/10" required minLength={3} />
            <Textarea value={message} onChange={(e)=>setMessage(e.target.value)} placeholder="Mesajınızı yazın..." className="bg-white/5 border-white/10 min-h-40" required minLength={5} />
            <Button disabled={loading} className="w-full bg-gradient-to-r from-fuchsia-500 to-indigo-500 hover:from-fuchsia-600 hover:to-indigo-600">
              <Send className="w-4 h-4 mr-2" /> {loading ? 'Gönderiliyor...' : 'Talep Oluştur'}
            </Button>
          </form>
          <div className="space-y-3">
            {tickets.length === 0 ? <div className="glass-card rounded-2xl p-8 text-center text-muted-foreground">Henüz destek talebi yok.</div> : tickets.map(t => (
              <div key={t.ticket_id} className="glass-card rounded-2xl p-5">
                <div className="flex items-start justify-between gap-3 mb-3">
                  <div>
                    <h2 className="font-semibold">{t.subject}</h2>
                    <p className="text-xs text-muted-foreground">{new Date(t.created_at).toLocaleString('tr-TR')}</p>
                  </div>
                  <span className="text-xs px-2 py-1 rounded-full bg-fuchsia-500/15 text-fuchsia-300 border border-fuchsia-500/20">{t.status}</span>
                </div>
                <div className="space-y-2">
                  {(t.messages || []).map((m, i) => (
                    <div key={i} className={`rounded-xl p-3 text-sm ${m.sender === 'admin' ? 'bg-emerald-500/10 border border-emerald-500/20' : 'bg-white/5 border border-white/10'}`}>
                      <p className="text-xs text-muted-foreground mb-1">{m.sender === 'admin' ? 'Destek' : 'Siz'}</p>
                      <p>{m.message}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
